import React, { FC } from 'react'
import styled from 'styled-components'
import { useCalendarContext } from '../../../context/calendar'
import Spacer from '../../Utility/Spacer'

const TimetableHeader: FC = () => {
  const { filtered } = useCalendarContext()

  return (
    <TimetableHeaderWrapper>
      <Spacer width={80.5} style={{ background: '#ffffff' }}></Spacer>
      {filtered.map((column, columnIndex) => {
        return (
          <CellText key={columnIndex} isLast={columnIndex === filtered.length - 1}>
            {column.name}
          </CellText>
        )
      })}
    </TimetableHeaderWrapper>
  )
}

export default TimetableHeader

const TimetableHeaderWrapper = styled.div`
  height: 65px;
  display: flex;
  justify-content: space-between;
  word-break: break-all;
  position: sticky;
  top: 0;
  z-index: 1;
`

// const Cell = styled.div`
//   width: 82.5px;
//   flex-shrink: 0;
//   position: sticky;
//   left: 0;
// `

type CellTextProps = {
  isLast: boolean
}

const CellText = styled.div<CellTextProps>`
  min-width: 145px;
  padding: 20px 8px 8px 8px;
  font-family: Inter;
  font-size: 22px;
  font-weight: 500;
  line-height: 28px;
  letter-spacing: 0em;
  text-align: left;
  flex: 1;
  border-right: ${({ isLast }) => (isLast ? 'none' : 'solid 1px #E0E0E0')};
  border-bottom: solid 1px #e0e0e0;
  background-color: #fafafa;
`
